export const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : '/api');

export const SALES_STAGES = [
  'Kwalifikacja leada',
  'Prezentacja oferty',
  'Negocjacje',
  'Domknięcie sprzedaży',
  'Upselling/Cross-selling',
  'Zbieranie referencji'
] as const;

// Re-export mappings for easy access
export { 
  getPriorityMapping, 
  getCategoryMapping,
  getFormalityMapping,
  getRelationshipMapping,
  getToneMapping,
  getSalesStageMapping,
  getQuestionCategoryMapping,
  PRIORITY_MAPPING,
  CATEGORY_MAPPING,
  FORMALITY_MAPPING,
  RELATIONSHIP_MAPPING,
  TONE_MAPPING,
  SALES_STAGE_MAPPING,
  QUESTION_CATEGORY_MAPPING
} from './mappings';

export const FILE_UPLOAD = {
  MAX_SIZE: 50 * 1024 * 1024, // 50MB for audio files
  ACCEPTED_TYPES: ['.pdf', '.txt', '.json', '.srt', '.mp3', '.wav', '.m4a', '.ogg'],
  ACCEPTED_MIME_TYPES: ['application/pdf', 'text/plain', 'application/json', 'text/json', 'text/srt', 'application/x-subrip', 'audio/mpeg', 'audio/wav', 'audio/mp4', 'audio/x-m4a', 'audio/ogg', 'audio/webm', 'audio/flac']
} as const;

export const MESSAGES = {
  ERRORS: {
    NO_TRANSCRIPT: 'Wprowadź transkrypt lub prześlij plik',
    ANALYSIS_FAILED: 'Analiza nie powiodła się',
    GENERIC: 'Wystąpił błąd'
  }
} as const;